import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'app-store': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faAppStore" */
        '@fortawesome/free-brands-svg-icons/faAppStore'
    ),
    'artstation': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faArtstation" */
        '@fortawesome/free-brands-svg-icons/faArtstation'
    ),
    'canadian-maple-leaf': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCanadianMapleLeaf" */
        '@fortawesome/free-brands-svg-icons/faCanadianMapleLeaf'
    ),
    'creative-commons-sampling-plus': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCreativeCommonsSamplingPlus" */
        '@fortawesome/free-brands-svg-icons/faCreativeCommonsSamplingPlus'
    ),
    'critical-role': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCriticalRole" */
        '@fortawesome/free-brands-svg-icons/faCriticalRole'
    ),
    'cuttlefish': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faCuttlefish" */
        '@fortawesome/free-brands-svg-icons/faCuttlefish'
    ),
    'digg': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDigg" */
        '@fortawesome/free-brands-svg-icons/faDigg'
    ),
    'draft2digital': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faDraft2digital" */
        '@fortawesome/free-brands-svg-icons/faDraft2digital'
    ),
    'facebook-messenger': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFacebookMessenger" */
        '@fortawesome/free-brands-svg-icons/faFacebookMessenger'
    ),
    'font-awesome': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faFontAwesomeLogoFull" */
        '@fortawesome/free-brands-svg-icons/faFontAwesomeLogoFull'
    ),
    'forumbee': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faForumbee" */
        '@fortawesome/free-brands-svg-icons/faForumbee'
    ),
    'guilded': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGuilded" */
        '@fortawesome/free-brands-svg-icons/faGuilded'
    ),
    'gulp': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faGulp" */
        '@fortawesome/free-brands-svg-icons/faGulp'
    ),
    'hacker-news': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faHackerNews" */
        '@fortawesome/free-brands-svg-icons/faHackerNews'
    ),
    'hire-a-helper': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faHireAHelper" */
        '@fortawesome/free-brands-svg-icons/faHireAHelper'
    ),
    'itunes': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faItunes" */
        '@fortawesome/free-brands-svg-icons/faItunes'
    ),
    'js': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faJs" */
        '@fortawesome/free-brands-svg-icons/faJs'
    ),
    'leanpub': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faLeanpub" */
        '@fortawesome/free-brands-svg-icons/faLeanpub'
    ),
    'node': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faNode" */
        '@fortawesome/free-brands-svg-icons/faNode'
    ),
    'openid': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faOpenid" */
        '@fortawesome/free-brands-svg-icons/faOpenid'
    ),
    'opensuse': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faOpensuse" */
        '@fortawesome/free-brands-svg-icons/faOpensuse'
    ),
    'product-hunt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faProductHunt" */
        '@fortawesome/free-brands-svg-icons/faProductHunt'
    ),
    'quinscape': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faQuinscape" */
        '@fortawesome/free-brands-svg-icons/faQuinscape'
    ),
    'readme': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faReadme" */
        '@fortawesome/free-brands-svg-icons/faReadme'
    ),
    'schlix': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSchlix" */
        '@fortawesome/free-brands-svg-icons/faSchlix'
    ),
    'shopify': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faShopify" */
        '@fortawesome/free-brands-svg-icons/faShopify'
    ),
    'square-letterboxd': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquareLetterboxd" */
        '@fortawesome/free-brands-svg-icons/faSquareLetterboxd'
    ),
    'square-pied-piper': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faSquarePiedPiper" */
        '@fortawesome/free-brands-svg-icons/faSquarePiedPiper'
    ),
    'square-youtube': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faYoutubeSquare" */
        '@fortawesome/free-brands-svg-icons/faYoutubeSquare'
    ),
    'tencent-weibo': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faTencentWeibo" */
        '@fortawesome/free-brands-svg-icons/faTencentWeibo'
    ),
    'wikipedia-w': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faWikipediaW" */
        '@fortawesome/free-brands-svg-icons/faWikipediaW'
    ),
    'xbox': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faXbox" */
        '@fortawesome/free-brands-svg-icons/faXbox'
    ),
    'yammer': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-brands-faYammer" */
        '@fortawesome/free-brands-svg-icons/faYammer'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>